import { BorderGridContainer, GridBox, Section } from '@ahmdigital/ui';
import { ReactNode } from 'react';
import classNames from 'classnames';

import { VariantType } from '../../../types/variant';
import styles from './styles.module.sass';

type WrappedSectionProps = {
  children: ReactNode;
  spacerSize?: number | 'None';
  variant?: VariantType;
  withBorder?: boolean;
  withInvert?: boolean;
  withWide?: boolean;
};

// Note: this component has been moved to ahm-ui, ahm-sales cleanup impending (FW-1251)
const WrappedSection = ({
  children,
  variant,
  withBorder = false,
  withInvert = false,
  withWide = false,
  spacerSize = 3,
}: WrappedSectionProps) => {
  const section = (
    <Section variant={[`paddingTopSpacer${spacerSize}`, `paddingBottomSpacer${spacerSize}`, styles.section, variant]}>
      {children}
    </Section>
  );
  return withBorder ? (
    <BorderGridContainer>
      <GridBox padding="0" backgroundColor={withInvert ? 'black' : 'white'}>
        <div
          className={classNames([
            styles.horizontalSpacingWrapper,
            withInvert ? styles.invert : null,
            withWide ? styles.wide : null,
          ])}
        >
          {section}
        </div>
      </GridBox>
    </BorderGridContainer>
  ) : (
    section
  );
};

export default WrappedSection;
